<button mat-button class="project-btn"
  [matMenuTriggerFor]="projectMenu"
  [disabled]="showLoading"
  (menuOpened)="onMenuOpened()">
  <span class="btn-content">
    @if (showLoading) {
      <mat-spinner diameter="16" class="inline-spinner"></mat-spinner>
      <span class="project-name">{{ 'PROJECT.SELECT' | translate }}</span>
    } @else {
      <mat-icon class="project-icon">folder_open</mat-icon>
      <span class="project-name">
        @if (currentProject) {
          <span class="trigger-cc">{{ currentProject.costCenterNumber }}</span>
          <span class="trigger-sep">-</span>{{ currentProject.name }}
        } @else {
          {{ 'PROJECT.SELECT' | translate }}
        }
      </span>
      <mat-icon class="chevron">expand_more</mat-icon>
    }
  </span>
</button>

<mat-menu #projectMenu="matMenu" class="project-dropdown">
  <!-- Search — swallows all keys except Escape so mat-menu keyboard nav doesn't fire -->
  <div class="project-search"
    (click)="$event.stopPropagation()"
    (keydown)="onSearchKeydown($event)">
    <mat-form-field appearance="fill" subscriptSizing="dynamic" class="search-field">
      <mat-icon matPrefix>search</mat-icon>
      <input #searchInput matInput
        [(ngModel)]="searchTerm"
        (ngModelChange)="filterProjects()"
        placeholder="{{ 'COMMON.SEARCH' | translate }}">
      </mat-form-field>
    </div>

    <!-- Project list — scrollable, search header stays fixed -->
    <div class="project-list">
      @for (project of filteredProjects; track project) {
        <button mat-menu-item
          (click)="selectProject(project.id)"
          [class.active-project]="project.id === selectedProject">
          <mat-icon>{{ project.id === selectedProject ? 'check' : '' }}</mat-icon>
          <span class="project-item-label">
            <span class="project-cc">{{ project.costCenterNumber }}</span>
            <span class="project-item-name">{{ project.name }}</span>
          </span>
        </button>
      }

      @if (filteredProjects.length === 0) {
        <div class="no-results">
          <mat-icon>search_off</mat-icon>
          <span>{{ 'COMMON.NO_RESULTS' | translate }}</span>
        </div>
      }
    </div>
  </mat-menu>
